<template>
	<el-cascader
	  :props="props"
	  :placeholder="placeholder"
	  v-model="packet"
	  :size="$store.state.isphone?'mini':''"
	  collapse-tags
	  clearable
	  style="width: 100%;">
	</el-cascader>
</template>

<script>
	export default {
		data() {
			return {
				props: {
					multiple: true,
					value: 'id',
					label: 'name',
					children: 'children',
					lazy: true,
					lazyLoad: (node, resolve) => {
						let val=node.path;
						if(val==null)
						{
							val=[];
						}
						if(val.length==0)
						{
							this.getterminal()
							.then((response)=>{
								if(response.data.code==1)
								{
									let data=response.data.data.list.map(value=>{
										return {
											id: value.id,
											name: value.name,
											leaf: false
										}
									})
									resolve(data);
								}
							})
						}
						else
						{
							this.getdevices({ terminal_id: val[0] })
							.then((response)=>{
								if(response.data.code==1)
								{
									let data=response.data.data.list.map(value=>{
										return {
											id: value.id,
											name: value.alias,
											leaf: true
										}
									})
									resolve(data);
								}
							})
						}
					}
				}
			}
		},
		methods:{
			
		},
		props: {
			value: {
				type: String,
				default: ''
			},
			placeholder: {
				type: String,
				default: ''
			}
		},
		mounted: function () {
			
		},
		computed:{
			packet: {
				get () {
					if(this.value=="")
					{
						return [];
					}
					let data=[],datas=this.value.split('-');
					for(let i=0;i<datas.length;i++)
					{
						let keydata=datas[i].split(':');
						let iddata=keydata[1].split(',');
						for(let j=0;j<iddata.length;j++)
						{
							data.push([keydata[0],iddata[j]]);
						}
					}
					return data;
				},
				set (value) {
					let data={},datas=[];
					for(let i=0;i<value.length;i++)
					{
						if(data[value[i][0]]==null)
						{
							data[value[i][0]]=[];
						}
						data[value[i][0]].push(value[i][1]);
					}
					for(let key in data)
					{
						datas.push(key+":"+data[key].join(","));
					}
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', datas.join("-"));
					}
					o.input();
				}
			}
		}
	}
</script>

<style>
</style>
